module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "180px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册送优惠券："
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "promotion-card"
  }, [_c('div', {
    staticClass: "promotion-card-header"
  }, [_vm._v("\n                优惠券\n                "), _c('a', {
    staticClass: "promotion-card-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("新增")])]), _vm._v(" "), _c('div', {
    staticClass: "promotion-card-body"
  }, [_c('ul', {
    staticClass: "promotion-card-list"
  }, _vm._l((_vm.coupons.checked), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "promotion-name"
    }, [_vm._v("\n                      " + _vm._s(item.title) + "\n                    ")]), _vm._v(" "), _c('el-input-number', {
      attrs: {
        "size": "mini",
        "controls-position": "right",
        "min": 1,
        "max": 10,
        "label": "描述文字"
      },
      model: {
        value: (item.count),
        callback: function($$v) {
          _vm.$set(item, "count", $$v)
        },
        expression: "item.count"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "remove-btn el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.removeChecked(index)
        }
      }
    })], 1)
  }), 0)])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择优惠券",
      "visible": _vm.coupons.dialog,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.coupons, "dialog", $event)
      },
      "open": _vm.onshowModal,
      "close": _vm.oncloseModal
    }
  }, [_c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.coupons.loading),
      expression: "coupons.loading"
    }],
    staticClass: "dialog-list clearfix"
  }, [_vm._l((_vm.coupons.list), function(item) {
    return [_c('li', {
      class: item.checked ? 'checked' : '',
      on: {
        "click": function($event) {
          return _vm.selectItems(item)
        }
      }
    }, [(item.checked) ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e(), _vm._v(" " + _vm._s(item.title))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.coupons.page.currentPage,
      "page-size": _vm.coupons.page.pageSize,
      "total": _vm.coupons.page.total
    },
    on: {
      "current-change": _vm.changeCouponsPage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._l((_vm.coupons.temp), function(item, index) {
    return [_c('li', [_vm._v(_vm._s(item.title))])]
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelSelected
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitSelected
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1bf81281", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bf81281"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/yibaoinfo.vue
// module id = 2513
// module chunks = 0